import { Component, ElementRef, Output, EventEmitter, ViewChild, ViewContainerRef, Input, ComponentFactoryResolver } from '@angular/core';
import { NavController, NavParams, Modal, AlertController, Events, ToastController, LoadingController } from 'ionic-angular';
import { LoginService } from '../../providers/login-service/login-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { EventServiceProvider } from '../../providers/event-service/event-service';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service'
declare var window: any;
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  model: any;
  fields: any;
  fieldIndex: number = 0;
  fieldslen: number = 0;
  //subs: Subscription;
  offLeft: string;
  @Input() sharedData: any;
  @Output() onlogin = new EventEmitter();
  @ViewChild('loadNewAccount', { read: ViewContainerRef, static: false }) loadNewAccount: ViewContainerRef;
  @ViewChild('loadAccount_Setup', { read: ViewContainerRef, static: false }) loadAccount_Setup: ViewContainerRef;
  @ViewChild("signin", { read: ViewContainerRef, static: false }) sign_outer: ElementRef;
  @ViewChild('facevideo', { read: ViewContainerRef, static: false }) facevid: ElementRef;
  @ViewChild('facecanvas', { read: ViewContainerRef, static: false }) facecanv: ElementRef;
  isStream: boolean = false;
  fvwidth: number = 200;
  fvheight: number = 0;
  myface;
  faceReg: boolean;
  recoverPasswordLink: any;
  //CREATE ACCOUNT
  signUpPage: boolean = false;
  sqlStatus: any;
  user_details: boolean = true;
  encryptedPwd: any;
  loader: any;
  mobileScreen: any;
  componentRef: any;
  input_field: any;
  emailValidation:any = /\S+@\S+\.\S+/;
  constructor(public loadingController: LoadingController, private driveService : DriveServiceProvider, private fb: FormBuilder, public toastCtrl: ToastController, public componentFactoryResolver: ComponentFactoryResolver, public navCtrl: NavController, public navParams: NavParams, public loginService: LoginService, public config: ConfigureServiceProvider, private eventObj: EventServiceProvider, public events: Events, private alertCtrl: AlertController, public toastController: ToastController, private EncrDecrService: EncrDecrServiceProvider, public configApiService: ConfigApiServiceProvider,public communicationServ:CommunicationServiceProvider) {
    this.model = { user: "", password: "" };
    this.fields = [{ id: 0, label: 'Username', field: 'user', ftype: 'text' }, { id: 1, label: 'Password', field: 'password', ftype: 'password' }]
    this.fieldslen = this.fields.length;
  }
  
  ngOnInit() {
    if (window.innerWidth < 700) {
      this.mobileScreen = true;
    }
    document.addEventListener('onautocomplete', (event) => {
      if(event){
        this.input_field = 'inputFields';
      }
   })
  }

  ngAfterViewInit() {
   
    this.position();
  }
  startSecCam() {
    let canvas = this.facecanv.nativeElement;
    let video = this.facevid.nativeElement;
    let that = this;
    var navigator = window.navigator;
    navigator['getMedia'] = (navigator.getUserMedia ||
      navigator['webkitGetUserMedia'] ||
      navigator['mozGetUserMedia'] ||
      navigator['msGetUserMedia']);

    navigator['getMedia'](
      {
        video: true,
        audio: false
      },
      function (stream) {
        if (navigator['mozGetUserMedia']) {
          video.mozSrcObject = stream;
        } else {
          var vendorURL = window.URL || window['webkitURL'];
          video.src = vendorURL.createObjectURL(stream);
        }
        video.play();
      },
      function (err) {
       
      }
    );

    video.addEventListener('canplay', function (ev) {
      if (!that.isStream) {
        that.fvheight = video.videoHeight / (video.videoWidth / (that.fvwidth));
        if (isNaN(that.fvheight)) {
          that.fvheight = that.fvwidth / (4 / 3);
        }

        video.setAttribute('width', that.fvwidth);
        video.setAttribute('height', that.fvheight);
        canvas.setAttribute('width', that.fvwidth);
        canvas.setAttribute('height', that.fvheight);
        that.isStream = true;
      }
    }, false);
  }
    dispatchSignProcess(v: string = null) {
    let fobj = this.fields[this.fieldIndex];
    this.eventObj.trigEvent({ event: "epcDesk:event:login", data: { cmdIndex: this.fieldIndex, label: fobj.label, value: v || fobj.value, field: fobj.field, ftype: fobj.ftype } })
  }

  doLogin() {
    let userIndex;
    if (this.sharedData) {
      if (this.sharedData['ReceiverEmail'] && this.sharedData['sharedInfo'].accessType == 'private') {
        if(this.sharedData["ShareType"] == 'File' && typeof(this.sharedData['ReceiverEmail']) == 'string'){
          userIndex = this.sharedData['ReceiverEmail'].split(',').findIndex(element => element == this.model.user)
        }else{
          let receiverEmailId = JSON.parse(this.sharedData['ReceiverEmail'])
          userIndex = receiverEmailId.findIndex(element => element['email_id'] == this.model.user)
        }
        if ( userIndex == -1) {
          const toast = this.toastCtrl.create({
            message: 'Entered EmailId is not correct',
            duration: 2000
          });
          toast.present();
        }
        else {
          this.loginUser();
        }
      }
    }
    else {
      this.loginUser();
    }
  }

  loginUser(){
    this.loginService.getSecurityToken(this.model.user, this.model.password,(respdata)=>{
      this.loginUserV();
    });
  }

  loginUserV() {
    this.loginService.loginuser(this.model.user, this.model.password).then((data) => {
      if (data.result === "success") {

        var adminInfo = data.admin.info;
        if (adminInfo) {
          var ut = adminInfo.usertype;
          var std = adminInfo.studio;
          var host = adminInfo.host;
          this.config.setUserLevel(false);
          this.config.setStudio(std);
          if (host) {
            localStorage.setItem("epcdesk::adminhost", host);
            this.config.setServerMode('custom', host);
          } else {
            this.config.setServerMode('dev');
          }
          localStorage.setItem("epcdesk::studio", std);
          localStorage.setItem("epcdesk::isAdmin", "false");
          if (String(ut) === '1') {
            this.config.setUserLevel(true);
            localStorage.setItem("epcdesk::isAdmin", "true");
          }
        }
        this.onlogin.emit({ state: true, regID: data.auid });
        this.driveService.broadcastInfo({ src: 'loginPage', event: 'passRegUserId', data: data.auid });


        this.passThroughDuoAuth(false);
      } else {

        let errcode = data.errorcode;
        if (errcode === 2) {
          this.onlogin.emit({ state: true, regID: null, data: data });
        } else {
          this.onlogin.emit({ state: false });
          alert(data.msg);
        }
      }

    }, (err) => {
      this.onlogin.emit({ state: false });
      alert(err.msg);
    })
  }
  clear() {
    this.model.user = "";
    this.model.password = "";
  }
  onforgot() {
    alert("Not Implemented!");
  }

  position() {
    let mel = document.getElementsByClassName("main")[0];
    let pos = mel.getBoundingClientRect();
  
    let off = (window.innerWidth - 100) / 2;
    this.offLeft = off + "px";
  }

  passThroughDuoAuth(bWhiteListedID) {

  }

  forgotPassword() {
   
    let alert = this.alertCtrl.create({
      title: 'Verify your identity',
      subTitle: "Enter Re-cover E-mail Id",
      inputs: [
        {
          name: "emailId",
          value: this.model.user
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
           
          }
        },
        {
          text: 'Ok',
          handler: data => {
            if (data["emailId"] && this.emailValidation.test(data["emailId"])){
              let urlParams = '&RecoverMail=' + data["emailId"];
              let encUrlParams = this.EncrDecrService.encrypt('DRIVESYNC123##', urlParams);
              let generateUrl: any = '';
              if (window.location.search) {
                generateUrl = window.location.origin + window.location.pathname + window.location.search + '&RecoverPassword=' + encUrlParams;
              } else {
                generateUrl = window.location.origin + window.location.pathname + '/?RecoverPassword=' + encUrlParams;
              }
              this.recoverPasswordLink = generateUrl;

              this.recoverPassword(data["emailId"]);
            } 
            else {
              if (!document.getElementsByClassName("validation-errors").length) {
                const input = document.getElementsByClassName("alert-input")[0];

                const validationErrors = document.createElement("div");
                validationErrors.className = "validation-errors";

                const errorMessage = document.createElement("small");
                errorMessage.classList.add("error-message");
                errorMessage.textContent = "Invalid email id";

                validationErrors.appendChild(errorMessage);

                input.insertAdjacentElement("afterend", validationErrors);
              }

              return false;
            }
          }
        }
      ]
    });
    alert.present();
  }

  recoverPassword(data) {
    let post_data = {};
    let body = this.convertHtml(data, this.recoverPasswordLink);
    post_data = { 'TOID': data, 'FROMID': this.loginService.defaultEmailId, 'BODY': body,'ShareType': 1,  'SUBJECT': 'Forgot Password Link' };
    let objPushParams = Object.assign({}, this.driveService.configApiService.driveApi.pushMailShareUser.params, post_data);
    this.driveService.configApiService.pushRequest(objPushParams, this.submitSucess);
    // post_data = {
    //   "client": "eprodcast",
    //   "rptname": "Send_Mail_Alert",
    //   "toid": data,
    //   "cc": "",
    //   "bcc": "",
    //   "fromid": "time@starport.ca",
    //   "subject": "Forgot Password Link",
    //   "body": body,
    //   "userid": "8"
    // }
    // this.configApiService.pushRequest(post_data, this.submitSucess)
  }

  convertHtml(text, link) {
    let bodyHtml: any = '';
    bodyHtml += '<div  style="width: 35%;"><table border="0" cellpadding="0" cellspacing="0" style="width: 100%;">' +
      '<thead border="0" cellpadding="0" cellspacing="0" width="78%"><tr><td>';
    bodyHtml += '<div style="margin: 12px;">Please click Open and reset your password</div>';
    bodyHtml += '</td></tr></thead><tbody style="padding: 12px;margin: 1px; background-color: #e6e6e694;" border="0" cellpadding="0" cellspacing="0">' +
      '<tr border="0" cellpadding="0" cellspacing="0"><td border="0" cellpadding="0" cellspacing="0">' +
      '<div style="margin: 12px;display: flex;"><div style="margin-left: 20px;"><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Google_Docs_logo.svg/740px-Google_Docs_logo.svg.png" style="width: 46px;">' +
      '</div><div style="margin-top: 25px;margin-left: 16px;"><span style="font-weight:bold">Recover Password</span></div></div>' +
      '</td></tr><tr border="0" cellpadding="0" cellspacing="0"><td border="0" cellpadding="0" cellspacing="0"><div style="margin: 12px;">' +
      "<a href='" + link + "' style='color: #fff;background-color: #467fff;padding:6px 21px;border: 1px solid;border-radius: 3px;font-size: 16px;margin-left: 8px;cursor: pointer;text-decoration:none'>open</a>" +
      '</div></td></tr></tbody><tfoot style="margin:1px;background-color: #cccccc;"><tr><td></td>' +
      '</tr></tfoot></table></div><br>' +
      '<div style="height: 50px;"><span style="margin-top:10px">Regards,<br><span>'+this.loginService.defaultEmailId+'</span></span></div>';
    return bodyHtml;
  }
  submitSucess = ((result) => {
    if (result == "SUCCESS") {
      let alert = this.alertCtrl.create({
        subTitle: 'thanks, you will receive a mail with the link to reset your password',
        buttons: ['ok']
      });
      alert.present();
    } else {
      const toast = this.toastController.create({
        message: result["message"],
        duration: this.configApiService.toastDuration,
      });
      toast.present();
    }
  })
  signUp() {
    this.signUpPage = true;
    this.loadCreateNewAccount();
  }

  loadCreateNewAccount() {
    // let componentFactory = this.componentFactoryResolver.resolveComponentFactory(CreateNewAccountComponent);
    // this.componentRef = this.loadNewAccount.createComponent(componentFactory);
    // this.componentRef.instance.cancelCreateAccount.subscribe(val => { this.cancelCreateAccount(val); });

  }

  cancelCreateAccount(e) {
    if (e == false) {
      this.loadNewAccount.clear();
      this.signUpPage = e;
    }
  }

  openAccountSetup() {
    this.signUpPage = true;
    this.loadAccountSetup();
  }
  loadAccountSetup() {
    // let componentFactory = this.componentFactoryResolver.resolveComponentFactory(AccountSetupComponent);
    // this.componentRef = this.loadAccount_Setup.createComponent(componentFactory);
    // this.componentRef.instance.cancelAccountSetup.subscribe(val => { this.cancelAccountSetup(val); });
    // this.componentRef.instance.getDBAccountDetails.subscribe(val => { this.getDBAccountDetails(val); });
  }

  cancelAccountSetup(e) {
    if (e == false) {
      this.loadAccount_Setup.clear();
      this.signUpPage = e;
    }
  }

  /* * * * * *
  * get Account Information for redirect URL 
  * * * * * */
  getDBAccountDetails(url) {
    window.location = url;
  }

}




// WEBPACK FOOTER //
// ./src/pages/login/login.ts